import axios from "axios";
import { API_URL } from "../../constants";
import { FuelBarcode } from "./fuelBarcodes.types";

export async function fetchFuelBarcodes(
  companyId: string
): Promise<FuelBarcode[]> {
  const res = await axios.get(`${API_URL}/${companyId}/fuel-barcodes`);
  return res.data.fuelBarcodes;
}

/** Upsert: pass an `id` to update an existing entry, omit it to create one.
 * Inactive duplicates are reactivated by the API (`reactivated: true`). */
export async function saveFuelBarcode(
  companyId: string,
  data: Partial<FuelBarcode>
): Promise<FuelBarcode & { reactivated?: boolean }> {
  const res = await axios.post(`${API_URL}/${companyId}/fuel-barcodes`, data);
  return {
    ...res.data.fuelBarcode,
    reactivated: !!res.data.reactivated,
  };
}
